
import React from "react";
import TocTocHeader from "@/components/TocTocHeader";
import TocTocHero from "@/components/TocTocHero";
import TocTocBenefits from "@/components/TocTocBenefits";
import TocTocBeforeAfter from "@/components/TocTocBeforeAfter";
import TocTocServices from "@/components/TocTocServices";
import TocTocHowItWorks from "@/components/TocTocHowItWorks";
import TocTocPortfolio from "@/components/TocTocPortfolio";
import TocTocTestimonials from "@/components/TocTocTestimonials";
import TocTocCTA from "@/components/TocTocCTA";
import TocTocFooter from "@/components/TocTocFooter";
import ClientOnly from "@/components/ClientOnly";

import SEOHead from "@/components/common/SEOHead";

const Index = () => {
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": "https://site.toctocbr.com/#website",
        "url": "https://site.toctocbr.com/",
        "name": "Toc Toc",
        "inLanguage": "pt-BR",
        "potentialAction": {
          "@type": "SearchAction",
          "target": "https://site.toctocbr.com/?q={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      },
      {
        "@type": ["Organization", "LocalBusiness", "ProfessionalService"],
        "@id": "https://site.toctocbr.com/#org",
        "name": "Toc Toc",
        "url": "https://site.toctocbr.com/",
        "logo": "https://site.toctocbr.com/logo.png",
        "description": "Fotógrafo imobiliário, filmmaker e social media imobiliário. Fotografia de arquitetura e interiores para corretores, imobiliárias, construtoras e anfitriões de temporada.",
        "telephone": "+55-47-99736-7396",
        "email": "contato@toctocbr.com",
        "sameAs": [
          "https://www.instagram.com/toctoc.br",
          "https://www.facebook.com/toctocbr"
        ],
        "areaServed": [
          { "@type": "City", "name": "Balneário Camboriú" },
          { "@type": "City", "name": "Camboriú" },
          { "@type": "City", "name": "Itajaí" },
          { "@type": "City", "name": "Itapema" },
          { "@type": "City", "name": "Porto Belo" },
          { "@type": "City", "name": "Bombinhas" },
          { "@type": "City", "name": "Navegantes" },
          { "@type": "State", "name": "Santa Catarina" },
          { "@type": "Country", "name": "Brasil" }
        ]
      },
      {
        "@type": "SiteNavigationElement",
        "@id": "https://site.toctocbr.com/#nav",
        "name": ["Serviços", "Portfólio", "Sobre Nós", "Cidades Atendidas", "Contato"],
        "url": [
          "https://site.toctocbr.com/servicos",
          "https://site.toctocbr.com/portfolio",
          "https://site.toctocbr.com/sobre",
          "https://site.toctocbr.com/cidades-atendidas",
          "https://site.toctocbr.com/contato"
        ]
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://site.toctocbr.com/#breadcrumbs",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Início", "item": "https://site.toctocbr.com/" },
          { "@type": "ListItem", "position": 2, "name": "Serviços", "item": "https://site.toctocbr.com/servicos" },
          { "@type": "ListItem", "position": 3, "name": "Portfólio", "item": "https://site.toctocbr.com/portfolio" }
        ]
      },
      {
        "@type": "ItemList",
        "@id": "https://site.toctocbr.com/#catalogo",
        "name": "Serviços Toc Toc",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "item": { "@id": "https://site.toctocbr.com/#serv-foto-imobiliaria" } },
          { "@type": "ListItem", "position": 2, "item": { "@id": "https://site.toctocbr.com/#serv-videos" } },
          { "@type": "ListItem", "position": 3, "item": { "@id": "https://site.toctocbr.com/#serv-arquitetura-interiores" } },
          { "@type": "ListItem", "position": 4, "item": { "@id": "https://site.toctocbr.com/#serv-airbnb" } },
          { "@type": "ListItem", "position": 5, "item": { "@id": "https://site.toctocbr.com/#serv-vistoria" } }
        ]
      },
      {
        "@type": "Service",
        "@id": "https://site.toctocbr.com/#serv-foto-imobiliaria",
        "serviceType": "Fotografia Imobiliária Profissional",
        "provider": { "@id": "https://site.toctocbr.com/#org" },
        "areaServed": [
          "Balneário Camboriú",
          "Camboriú",
          "Itajaí",
          "Itapema",
          "Porto Belo",
          "Bombinhas",
          "Navegantes",
          "Santa Catarina",
          "Brasil"
        ],
        "description": "Fotos profissionais de imóveis para venda, locação e lançamentos. Edição premium e entrega em até 48h.",
        "offers": {
          "@type": "Offer",
          "url": "https://site.toctocbr.com/contato",
          "availability": "https://schema.org/InStock",
          "priceCurrency": "BRL"
        }
      },
      {
        "@type": "Service",
        "@id": "https://site.toctocbr.com/#serv-videos",
        "serviceType": "Vídeos Imobiliários (Filmmaker Imobiliário)",
        "provider": { "@id": "https://site.toctocbr.com/#org" },
        "description": "Produção de vídeos imobiliários e cortes para redes sociais, com captação e edição profissional.",
        "offers": {
          "@type": "Offer",
          "url": "https://site.toctocbr.com/contato",
          "availability": "https://schema.org/InStock",
          "priceCurrency": "BRL"
        }
      },
      {
        "@type": "Service",
        "@id": "https://site.toctocbr.com/#serv-arquitetura-interiores",
        "serviceType": "Fotografia de Arquitetura e Interiores",
        "provider": { "@id": "https://site.toctocbr.com/#org" },
        "description": "Fotografia técnica para projetos de arquitetura e interiores, com fidelidade cromática e composição avançada.",
        "offers": {
          "@type": "Offer",
          "url": "https://site.toctocbr.com/contato",
          "availability": "https://schema.org/InStock",
          "priceCurrency": "BRL"
        }
      },
      {
        "@type": "Service",
        "@id": "https://site.toctocbr.com/#serv-airbnb",
        "serviceType": "Fotografia para Airbnb e Temporada",
        "provider": { "@id": "https://site.toctocbr.com/#org" },
        "description": "Ensaios com foco em conversão nas plataformas de temporada (Airbnb/Booking), destacando experiências e ambientes instagramáveis.",
        "offers": {
          "@type": "Offer",
          "url": "https://site.toctocbr.com/contato",
          "availability": "https://schema.org/InStock",
          "priceCurrency": "BRL"
        }
      },
      {
        "@type": "Service",
        "@id": "https://site.toctocbr.com/#serv-vistoria",
        "serviceType": "Vistoria Imobiliária",
        "provider": { "@id": "https://site.toctocbr.com/#org" },
        "description": "Relatórios fotográficos e em vídeo documentando o estado do imóvel para locação e laudos.",
        "offers": {
          "@type": "Offer",
          "url": "https://site.toctocbr.com/contato",
          "availability": "https://schema.org/InStock",
          "priceCurrency": "BRL"
        }
      },
      {
        "@type": "FAQPage",
        "@id": "https://site.toctocbr.com/#faq",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Quanto custa um fotógrafo imobiliário em Balneário Camboriú?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "O valor depende da metragem, deslocamento e escopo (fotos, vídeo, drone, social). Solicite orçamento rápido via formulário ou WhatsApp."
            }
          },
          {
            "@type": "Question",
            "name": "Qual é o prazo de entrega das fotos?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Entrega padrão em até 48 horas após a sessão, em alta resolução, pronta para anúncios."
            }
          },
          {
            "@type": "Question",
            "name": "Vocês fazem vídeos imobiliários e cortes para redes sociais?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Sim. Produzimos vídeos e versões verticais (Reels/Shorts) quando necessário."
            }
          },
          {
            "@type": "Question",
            "name": "Atendem Airbnb e temporada?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Sim. Ensaio com foco em conversão e estética acolhedora para Airbnb/Booking."
            }
          },
          {
            "@type": "Question",
            "name": "Quais cidades vocês atendem?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Balneário Camboriú, Camboriú, Itajaí, Itapema, Porto Belo, Bombinhas e Navegantes, com deslocamentos sob consulta."
            }
          }
        ]
      },
      {
        "@type": "BreadcrumbList",
        "@id": "https://site.toctocbr.com/#breadcrumbs",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Início",
            "item": "https://site.toctocbr.com/"
          }
        ]
      }
    ]
  };

  return (
    <>
      <SEOHead
        title="Fotografia & Vídeo Imobiliário | Drone, Social Media & Airbnb — Toc Toc"
        description="Fotos e vídeos imobiliários, social media, fotografia de arquitetura e interiores. Clique em Serviços para ver pacotes e Portfólio para cases. SC: BC, Camboriú, Itajaí, Itapema, Porto Belo, Bombinhas, Navegantes."
        keywords="Toc Toc, Grupo Toc Toc, fotógrafo imobiliário, fotografia imobiliária, vídeos imobiliários, filmmaker imobiliário, social media imobiliário, fotografia de arquitetura, fotografia de interiores, fotografia para Airbnb, Balneário Camboriú, Camboriú, Itajaí, Itapema, Porto Belo, Bombinhas, Navegantes, Santa Catarina, Brasil"
        canonicalUrl="/"
        schema={schema}
        ogTitle="Toc Toc | Fotografia & Vídeo Imobiliário em SC"
        ogDescription="Fotos e vídeos imobiliários, arquitetura/interiores e social media. Entrega em 48h."
        twitterTitle="Toc Toc | Fotografia & Vídeo Imobiliário"
        twitterDescription="Fotógrafo imobiliário, filmmaker e social media em Santa Catarina."
        ogImage="https://site.toctocbr.com/og-image.jpg"
        ogImageAlt="Toc Toc — fotografia imobiliária e vídeos profissionais"
        titleTemplate={null}
        prefetchLinks={["/servicos", "/portfolio", "/sobre", "/cidades-atendidas"]}
      />
      
      <div className="min-h-screen bg-white" suppressHydrationWarning>
        <TocTocHeader />
        <main>
          <section id="hero" aria-label="Fotografia profissional de imóveis">
            <ClientOnly>
              <TocTocHero />
            </ClientOnly>
          </section>
          <section id="beneficios" aria-label="Benefícios da fotografia profissional">
            <TocTocBenefits />
          </section>
          <section id="antes-depois" aria-label="Comparação antes e depois">
            <ClientOnly>
              <TocTocBeforeAfter />
            </ClientOnly>
          </section>
          <section id="servicos" aria-label="Nossos serviços de fotografia imobiliária">
            <TocTocServices />
          </section>
          <section id="como-funciona" aria-label="Como funciona nosso processo">
            <TocTocHowItWorks />
          </section>
          <section id="portfolio" aria-label="Portfólio de trabalhos realizados">
            <ClientOnly>
              <TocTocPortfolio />
            </ClientOnly>
          </section>
          <section id="depoimentos" aria-label="Depoimentos de clientes satisfeitos">
            <ClientOnly>
              <TocTocTestimonials />
            </ClientOnly>
          </section>
          <section id="contato" aria-label="Entre em contato conosco">
            <TocTocCTA />
          </section>
        </main>
        <TocTocFooter />
      </div>
    </>
  );
};

export default Index;
